import React, { useState, useMemo } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { resetPassword } from '../api';

export default function ResetPasswordPage() {
  const location = useLocation();
  const navigate = useNavigate();
  const token = useMemo(() => new URLSearchParams(location.search).get('token') || '', [location.search]);

  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (password.length < 8) {
      setError('Le mot de passe doit contenir au moins 8 caractères.');
      return;
    }
    if (password !== confirm) {
      setError('Les deux mots de passe ne correspondent pas.');
      return;
    }
    setLoading(true);
    try {
      await resetPassword(token, password);
      setDone(true);
      setTimeout(() => navigate('/login'), 2500);
    } catch (err) {
      setError(err.message || 'Une erreur est survenue.');
    }
    setLoading(false);
  };

  // Token absent dans l'URL : on n'affiche pas le formulaire — l'utilisateur
  // est arrivé ici sans cliquer sur un vrai lien.
  if (!token) {
    return (
      <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: '100%', maxWidth: 460, padding: 24 }}>
          <div className="card" style={{ padding: 40 }}>
            <h1 style={{ fontSize: 22, marginBottom: 8, textAlign: 'center' }}>Lien invalide</h1>
            <p style={{ textAlign: 'center', color: 'var(--text-light)', fontSize: 13.5, marginBottom: 24 }}>
              Le lien de réinitialisation est incomplet ou a déjà été utilisé.
              Demandez un nouveau lien depuis l'écran de connexion.
            </p>
            <Link to="/forgot-password" className="btn btn-primary" style={{
              width: '100%', justifyContent: 'center', padding: '12px 0', fontSize: 14,
            }}>
              Demander un nouveau lien
            </Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ minHeight: '80vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ width: '100%', maxWidth: 460, padding: 24 }}>
        <div className="card" style={{ padding: 40 }}>
          <h1 style={{ fontSize: 22, marginBottom: 8, textAlign: 'center' }}>Nouveau mot de passe</h1>
          <p style={{ textAlign: 'center', color: 'var(--text-light)', marginBottom: 28, fontSize: 13.5, lineHeight: 1.55 }}>
            Choisissez un nouveau mot de passe (minimum 8 caractères).
          </p>

          {done ? (
            <div style={{
              background: '#E8F5E9', color: '#1B5E20',
              padding: 16, borderRadius: 8, fontSize: 13.5, lineHeight: 1.55,
              textAlign: 'center',
            }}>
              <strong>Mot de passe mis à jour.</strong>
              <br />
              Redirection vers la page de connexion...
            </div>
          ) : (
            <>
              {error && (
                <div style={{
                  background: '#FFEBEE', color: '#C62828',
                  padding: 12, borderRadius: 8, marginBottom: 16, fontSize: 14,
                }}>
                  {error}
                </div>
              )}
              <form onSubmit={handleSubmit}>
                <div style={{ marginBottom: 16 }}>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6, color: 'var(--text-light)' }}>
                    Nouveau mot de passe
                  </label>
                  <input
                    type="password" value={password} onChange={e => setPassword(e.target.value)} required
                    autoFocus autoComplete="new-password" minLength={8}
                    style={{ width: '100%', padding: '12px 16px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 14, fontFamily: 'inherit' }}
                    placeholder="Au moins 8 caractères"
                  />
                </div>
                <div style={{ marginBottom: 24 }}>
                  <label style={{ display: 'block', fontSize: 13, fontWeight: 600, marginBottom: 6, color: 'var(--text-light)' }}>
                    Confirmer le mot de passe
                  </label>
                  <input
                    type="password" value={confirm} onChange={e => setConfirm(e.target.value)} required
                    autoComplete="new-password" minLength={8}
                    style={{ width: '100%', padding: '12px 16px', border: '1px solid var(--border)', borderRadius: 8, fontSize: 14, fontFamily: 'inherit' }}
                    placeholder="Saisissez à nouveau le mot de passe"
                  />
                </div>
                <button type="submit" className="btn btn-primary" disabled={loading || !password || !confirm}
                  style={{ width: '100%', justifyContent: 'center', padding: '14px 0', fontSize: 15 }}>
                  {loading ? 'Mise à jour...' : 'Choisir ce mot de passe'}
                </button>
              </form>
              <div style={{ textAlign: 'center', marginTop: 20 }}>
                <Link to="/login" style={{ fontSize: 14 }}>Retour à la connexion</Link>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
